<template>
    <div>
        <div class="userinfo">
            <div class="header">
                <img class="headerimg" :src="headimgBase64" alt="" style="margin-right:5px;display:block">
            </div>
            <div class="weui-cells">
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>您的昵称</p>
                    </div>
                    <div class="weui-cell__ft">{{active.user?active.user.nickname.substr(0,6):'--'}}</div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>主手机号</p>
                    </div>
                    <div class="weui-cell__ft">{{active.user?active.user.phoneMain:'--'}}</div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>兑换状态</p>
                    </div>
                    <div class="weui-cell__ft" style="color: red;">{{active.statusStr}}</div>
                </div>
            </div>
            <div class="header">
                <img class="qrimg" :src="'data:image/png;base64,'+active.qrImage" alt="" v-if="active.qrImage">
            </div>
            <div class="qr-info">
                兑换二维码
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      active: {},
      headimgBase64: config.defaultImgBase64
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    axios
      .get("/api/sa/getByOpenid")
      .then(res => {
        this.active = res.data.data;
        if(this.active.status == 0) {
            this.active.statusStr = "未兑换";
        }else if(this.active.status == 1) {
            this.active.statusStr = "已兑换";
        }else {
            this.active.statusStr = "--";
        }
        if (this.active.user) {
          this.headimgBase64 =
            "data:image/png;base64," + this.active.user.headimgBase64;
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style scoped>
.userinfo {
  margin: 20px;
  border: 1px solid #eee;
  padding: 20px 10px 10px 10px;
}
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.headerimg {
  width: 100px;
  height: 100px;
  border-radius: 100px;
}
.qrimg {
  width: 200px;
  height: 200px;
}
.qr-info {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-top: -10px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>




// WEBPACK FOOTER //
// src/components/actives/subscribe.vue